import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { ComponentProps } from 'react';

import { FixturePickerItem } from '@sorare/core/src/components/lobby/FixturePickerItem';

import { getFixtureState } from '#src/lib/so5.ts';

import type { LobbyFixturePickerItem_so5Fixture } from './__generated__/index.graphql.ts';

type Props = {
  so5Fixture: Nullable<LobbyFixturePickerItem_so5Fixture>;
} & Omit<ComponentProps<typeof FixturePickerItem>, 'fixtureState'>;

export const LobbyFixturePickerItem = ({
  so5Fixture,
  ...otherProps
}: Props) => {
  const fixtureState = getFixtureState(so5Fixture);
  return (
    <FixturePickerItem
      {...otherProps}
      gameWeek={so5Fixture?.shortDisplayName}
      eventType={so5Fixture?.eventType}
      fixtureState={fixtureState}
      startDate={so5Fixture?.startDate}
      endDate={so5Fixture?.endDate}
      expectedRewardsDistributionDate={
        so5Fixture?.expectedRewardsDistributionDate
      }
    />
  );
};

LobbyFixturePickerItem.fragments = {
  so5Fixture: gql`
    fragment LobbyFixturePickerItem_so5Fixture on So5Fixture {
      slug
      eventType
      aasmState
      live
      startDate
      endDate
      shortDisplayName
      expectedRewardsDistributionDate
    }
  ` as TypedDocumentNode<LobbyFixturePickerItem_so5Fixture>,
};
